<template>
  <div class="comp-header-title">
    <div class="title-area">{{ PDTitle }}</div>
  </div>
</template>

<script>
export default {
  props: {
    PDTitle: String,
  },
};
</script>

<style lang="scss" src="../scss/comp-header-title.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/CompHeaderTitle.vue